"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIncomingError;

var _react = require("react");

var _states = require("../validation/states");

function useIncomingError(errorMessage, hasError, setValidationState) {
  (0, _react.useEffect)(function () {
    if (hasError) {
      setValidationState({
        msg: errorMessage || "Error",
        type: "error"
      });
    } else {
      setValidationState(_states.validState);
    }
  }, [errorMessage, hasError, setValidationState]);
}